import React from 'react';
import * as styles from './iconButton.module.scss';

interface IIconButtonProps {
  name?: string;
  type?: 'submit' | 'button';
  onClick?: (e: React.MouseEvent) => void;
  children: React.ReactNode;
}

export const IconButton = ({ name = '', type = 'button', onClick, children }: IIconButtonProps) => (
  <>
    {onClick ? (
      <button
        aria-label={name}
        className={styles.iconButton}
        type={type === 'button' ? 'button' : 'submit'}
        onClick={(e) => onClick(e)}
      >
        {children}
      </button>
    ) : (
      <div className={styles.iconButton}>{children}</div>
    )}
  </>
);
